import React, { lazy } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Sparkles, Gift, BookOpen, Music, ClipboardList, Calendar } from 'lucide-react';
import { useCurrency } from '../hooks/useCurrency';
const products = [{
  image: 'https://cdn.magicpatterns.com/uploads/cZL3pXspR9iE4oZtgNYxPi/SISTEMA_ANTICAOS_COVER_1_optimizada.png',
  title: 'Ebook Premium',
  description: 'Sistema AntiCaos PRO™ — El método completo en formato digital',
  icon: BookOpen
}];
const bonuses = [{
  icon: Music,
  title: 'Meditaciones Guiadas',
  description: 'Audio meditaciones para reprogramar tu mente y sostener la disciplina desde adentro.'
}, {
  icon: ClipboardList,
  title: 'Workbook Interactivo',
  description: 'Ejercicios prácticos para aplicar el sistema paso a paso en tu vida real.'
}, {
  icon: Calendar,
  title: 'Protocolo de 30 Días',
  description: 'Plan diario para que nunca más rompas el sistema. Estructura que se sostiene sola.'
}];
export function ProductShowcaseSection() {
  const {
    formatPrice
  } = useCurrency();
  return <Section id="experiencia-angelical" className="bg-transparent relative overflow-hidden" data-id="element-169">
      <div className="relative z-10" data-id="element-170">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-171">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black/50 backdrop-blur-sm border border-[#D4AF37]/30 mb-6" data-id="element-172">
            <Sparkles className="w-5 h-5 text-[#D4AF37]" data-id="element-173" />
            <span className="text-[#D4AF37] font-medium" data-id="element-174">Todo Incluido</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl md:text-5xl font-bold text-white mb-4 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-175">
            Lo que obtienes con el{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#F5D76E]" data-id="element-176">
              Sistema AntiCaos PRO™
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-200 max-w-2xl mx-auto drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]" data-id="element-177">
            Un sistema completo con todo lo que necesitas para transformar tu
            disciplina de raíz
          </motion.p>
        </div>

        {/* Main Product */}
        <div className="max-w-sm mx-auto mb-12" data-id="element-178">
          {products.map((product, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="group" data-id="element-179">
              <div className="relative aspect-square rounded-2xl overflow-hidden bg-black/40 backdrop-blur-sm border border-[#D4AF37]/20 mb-4 shadow-xl" data-id="element-180">
                <img src={product.image} alt={product.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-181" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1 text-center drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]" data-id="element-182">
                {product.title}
              </h3>
              <p className="text-sm text-gray-300 text-center" data-id="element-183">
                {product.description}
              </p>
            </motion.div>)}
        </div>

        {/* Bonuses */}
        <div className="mb-12 max-w-3xl mx-auto" data-id="element-184">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center text-[#D4AF37] font-bold text-lg uppercase tracking-widest mb-8" data-id="element-185">
            + 3 Bonos Incluidos
          </motion.p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-186">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="p-6 rounded-2xl bg-black/50 backdrop-blur-sm border border-[#D4AF37]/20 text-center" data-id="element-187">
                <div className="w-12 h-12 rounded-full bg-[#D4AF37]/15 flex items-center justify-center mx-auto mb-4" data-id="element-188">
                  <bonus.icon className="w-6 h-6 text-[#D4AF37]" data-id="element-189" />
                </div>
                <h4 className="text-white font-bold mb-2" data-id="element-190">{bonus.title}</h4>
                <p className="text-sm text-gray-400 leading-relaxed" data-id="element-191">
                  {bonus.description}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Bundle CTA */}
        <motion.div id="paquete-completo" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex justify-center" data-id="element-192">
          <a href="https://pay.hotmart.com/M104286251F?bid=1770346803141" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-6 py-4 rounded-2xl bg-black/60 backdrop-blur-md border border-[#D4AF37]/40 shadow-2xl hover:border-[#D4AF37]/70 hover:shadow-[0_0_30px_rgba(212,175,55,0.3)] transition-all duration-300 cursor-pointer" data-id="element-193">
            <Gift className="w-8 h-8 text-[#D4AF37]" data-id="element-194" />
            <div className="text-left" data-id="element-195">
              <p className="text-white font-bold drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]" data-id="element-196">
                ¡Quiero el Sistema AntiCaos PRO™!
              </p>
              <p className="text-xs text-gray-400" data-id="element-197">Ebook + 3 bonos incluidos</p>
            </div>
            <div className="ml-4 px-4 py-2 rounded-lg bg-[#D4AF37]/20" data-id="element-198">
              <div className="flex flex-col items-center" data-id="element-199">
                <span className="text-sm text-gray-400 line-through" data-id="element-200">
                  {formatPrice(47)}
                </span>
                <span className="text-2xl font-black text-[#D4AF37]" data-id="element-201">
                  {formatPrice(17)}
                </span>
              </div>
            </div>
          </a>
        </motion.div>
      </div>
    </Section>;
}